export default __webpack_public_path__ + "ec4616e7b8e5728f59b64e37d28ac6ec.svg";